import React from "react";
import type { Car } from "../../../types";
import { ActionButton, ClientCarCard, Icons } from "../../shared";

interface CarsListViewProps {
  cars: Car[];
  onEdit: (car: Car) => void;
  onDelete: (carId: number) => void;
}

function formatDate(dateString: string): string {
  try {
    return new Date(dateString).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "N/A";
  }
}

export const CarsListView: React.FC<CarsListViewProps> = ({
  cars,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-4">
      {cars.map((car) => (
        <ClientCarCard
          key={car.id}
          car={car}
          meta={
            <>
              Cadastrado em
              <br />
              <span className="font-medium text-gray-500">
                {formatDate(car.createdAt)}
              </span>
            </>
          }
          actions={
            <div className="grid grid-cols-2 gap-2">
              <ActionButton
                variant="outline"
                size="sm"
                onClick={() => onEdit(car)}
                icon={<Icons.Edit sx={{ fontSize: 16 }} />}
                className="w-full justify-center"
              >
                Editar
              </ActionButton>
              <ActionButton
                variant="danger"
                size="sm"
                onClick={() => onDelete(car.id)}
                icon={<Icons.Delete sx={{ fontSize: 16 }} />}
                className="w-full justify-center"
              >
                Excluir
              </ActionButton>
            </div>
          }
        />
      ))}
    </div>
  );
};
